<div class="edit-label-dialog">
  <app-popup-top-line></app-popup-top-line>
  <div class="edit-label-dialog-header">
    <div class="title">
      {{ 'editLabelDialog.editLabelTitle' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="edit-label-dialog-body">
    <div class="textarea textarea-show">
      <textarea
        type="text"
        maxlength="20"
        placeholder="Enter label name"
        disabled
        value="{{ inputData.label.displayName }}"
        [ngStyle]="{
          'background-color': getLabelTransparentBackgroundColor(),
        }"
      ></textarea>
    </div>

    <div class="edit-label-dialog-body-title">
      {{ 'editLabelDialog.newLabelNameTitle' | labelsProvider }}
    </div>
    <div class="textarea">
      <textarea
        type="text"
        maxlength="30"
        value="{{ inputData.label.displayName }}"
        (input)="onNameChange($event)"
      ></textarea>
    </div>

    <div class="edit-label-dialog-body-title">
      {{ 'editLabelDialog.newLabelColorTitle' | labelsProvider }}
    </div>
    <input type="color" value="{{ inputData.label.color }}" class="color-picker" (input)="onColorChange($event)" />
    <div class="section-divider"></div>
  </div>
  <div class="edit-label-dialog-footer">
    <button class="delete" (click)="deleteButtonClick()">
      <img src="assets/images/common/delete.svg" />
      <span>{{ 'editLabelDialog.deleteButtonText' | labelsProvider }}</span>
    </button>
    <button class="edit" (click)="editButtonClick()" [ngClass]="{ 'edit-disabled': !inputData.label.displayName }">
      <span>{{ 'editLabelDialog.editButtonText' | labelsProvider }}</span>
    </button>
  </div>
</div>
